export default __webpack_public_path__ + "static/media/14EF776D-0DD7-42B9-A06A-4EC17D691D48.ee1a19f5.jpg";